import { render, staticRenderFns } from "./BadgePicker.vue?vue&type=template&id=7be25daa"
import script from "./BadgePicker.vue?vue&type=script&lang=js"
export * from "./BadgePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports